<template>
  <div class="incentiveTravelPage">
    <div class="banner"><img src="../assets/IncentiveTravel/banner.png" alt="" /></div>
    <div class="incentiveTravelContent">
      <div class="boutiqueService">
        <h2>一站式精品服务</h2>
        <div class="english">— ONE-STOP BOUTIQUE SERVICE —</div>
        <div class="boutiqueServiceC">
          <ul class="clearfix">
            <li v-for="(list, index) in boutiqueServiceList" :key="index">
              <img :src="list.imgUrl" alt="" />
              <p v-html="list.name">{{ list.name }}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="travelSecurity">
        <h2>旅游4大保障</h2>
        <div class="english">— FOUR GUARANTEES FOR TOURISM —</div>
        <div class="travelSecurityC clearfix">
          <div class="line"></div>
          <ul class="clearfix">
            <li>
              <img src="../assets/IncentiveTravel/safeguard1.png" alt="" />
              <div class="name">安全有保障</div>
              <p>免费提供旅游意外险</p>
            </li>
            <li>
              <img src="../assets/IncentiveTravel/safeguard2.png" alt="" />
              <div class="name">产品有保障</div>
              <p>覆盖90%以上旅游产品</p>
            </li>
            <li>
              <img src="../assets/IncentiveTravel/safeguard3.png" alt="" />
              <div class="name">服务有保障</div>
              <p>管家式旅游服务</p>
            </li>
            <li>
              <img src="../assets/IncentiveTravel/safeguard4.png" alt="" />
              <div class="name">品牌有保障</div>
              <p>政府指定机票供应商</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="expansionCase">
        <h2>团队拓展案例</h2>
        <div class="english">— EXPANSION CASE —</div>
        <div class="expansionCaseC clearfix">
          <div class="caseLeft"><img src="../assets/IncentiveTravel/case1.png" alt="" /></div>
          <div class="caseright"><img src="../assets/IncentiveTravel/case2.png" alt="" /></div>
        </div>
      </div>
      <div class="businessCooperation">
        <h2>企业旅游需求</h2>
        <div class="english">— BUSINESS COOPERATION —</div>
        <div class="businessCooperationC">
          <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item prop="user"><el-input v-model="ruleForm.user" autocomplete="off" placeholder="联系人"></el-input></el-form-item>
            <el-form-item prop="phone"><el-input v-model="ruleForm.phone" autocomplete="off" placeholder="联系电话"></el-input></el-form-item>
            <el-form-item prop="date"><el-date-picker type="date" placeholder="出行日期" v-model="ruleForm.date" style="width: 100%;" value-format="yyyy-MM-dd" :picker-options="pickerOptions"></el-date-picker></el-form-item>
            <el-form-item prop="people"><el-input v-model="ruleForm.people" autocomplete="off" placeholder="出行人数" maxlength='10'></el-input></el-form-item>
            <el-form-item prop="day"><el-input v-model="ruleForm.day" autocomplete="off" placeholder="出行天数" maxlength='10'></el-input></el-form-item>
            <el-form-item prop="budget"><el-input v-model="ruleForm.budget" autocomplete="off" placeholder="人均预算" maxlength='20'></el-input></el-form-item>
            <el-form-item prop="site"><el-input v-model="ruleForm.site" autocomplete="off" placeholder="旅游地点"></el-input></el-form-item>
            <el-form-item><el-button type="primary" @click="submitForm('ruleForm')">提交</el-button></el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {postHttp} from '../../common/http'
export default {
  name: 'IncentiveTravel',
  data() {
    return {
      boutiqueServiceList: [
        {
          imgUrl: require('../assets/IncentiveTravel/serve1.png'),
          name: '专属定制方案</br>更满意'
        },
        {
          imgUrl: require('../assets/IncentiveTravel/serve2.png'),
          name: '旅游管家服务</br>更快速'
        },
        {
          imgUrl: require('../assets/IncentiveTravel/serve3.png'),
          name: '精品旅游攻略</br>更畅快'
        },
        {
          imgUrl: require('../assets/IncentiveTravel/serve4.png'),
          name: '一站式服务体验</br>更省心'
        }
      ],
      ruleForm: {
        user: '',
        phone: '',
        people: '',
        day: '',
        budget: '',
        site: '',
        date: ''
      },
      rules: {
        user: [{ required: true, message: '联系人不能为空',  trigger: 'blur' }],
        phone: [
          { required: true, message: '手机号不能为空',  trigger: 'blur' },
          {
            pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[026789])\d{8}$/,
            message: '请输入正确的手机号码'
          }
        ],
        people: [{ required: true, message: '出行人数不能为空',  trigger: 'blur' },
 {
            pattern: /^\+?[1-9][0-9]*$/,
            message: '请输入整数'
          }
        ],
        day: [{ required: true, message: '出行天数不能为空',  trigger: 'blur' },
        {
                   pattern: /^\+?[1-9][0-9]*$/,
                   message: '请输入整数'
                 }
        ],
        budget: [{ required: true, message: '人均预算不能为空', trigger: 'blur' }],
        site: [{ required: true, message: '旅游地点不能为空', trigger: 'blur' }],
        date: [{ required: true, message: '出行日期不能为空',  trigger: 'blur' }]
      },
      pickerOptions:{
        disabledDate(time) {
          return time.getTime() < (Date.now() - 3600 * 1000 * 24);
        },
      }
    };
  },
  methods: {
    isInteger(obj) {
     return (obj | 0) === obj
    },
    submitForm(formName) {
      if(this.ruleForm.user == ''){
        this.$message.error('联系人不能为空');
        return false;
      }
      if(this.ruleForm.phone == ''){
        this.$message.error('联系电话不能为空');
        return false;
      }else{
        let regs = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[026789])\d{8}$/;
        if(!regs.test(this.ruleForm.phone)){
          this.$message.error('请输入正确的手机号');
          return false;
        }
      }
      if(this.ruleForm.date == ''){
        this.$message.error('出行日期不能为空');
        return false;
      }
      if(this.ruleForm.people == ''){
        this.$message.error('出行人数不能为空');
        return false;
      }else{
        let regs = /^\+?[1-9][0-9]*$/
        if(!regs.test(this.ruleForm.people)){
          this.$message.error('请输入整数');
          return false;
        }
      }
      if(this.ruleForm.day == ''){
        this.$message.error('出行天数不能为空');
        return false;
      }else{
        let regs = /^\+?[1-9][0-9]*$/
        if(!regs.test(this.ruleForm.day)){
          this.$message.error('请输入整数');
          return false;
        }
      }
      if(this.ruleForm.budget == ''){
        this.$message.error('人均预算不能为空');
        return false;
      }
      if(this.ruleForm.site == ''){
        this.$message.error('旅游地点不能为空');
        return false;
      }
      let _this = this;
      this.$refs[formName].validate(function(valid){
        if (valid) {
          let data = {
            contactName:_this.ruleForm.user,
            contactPhone:_this.ruleForm.phone,
            tripTime:_this.ruleForm.date,
            peopleNum:Number(_this.ruleForm.people),
            tripDays:Number(_this.ruleForm.day),
            perBudget:_this.ruleForm.budget,
            tripPlace:_this.ruleForm.site,
          };
            postHttp(_this.constants.INTERFACE_LIST.travelDemand,data).then((res) => {
              _this.$message.success('提交成功，我们会及时联系您。')
            }, (e) => {
              _this.$message.error(e.message || '提交失败')
            })
          } else {
            _this.$message.warning('请正确填写信息')
            return false
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  mounted() {
  },
  activated(){
    this.resetForm('ruleForm');
  }
};
</script>

<style lang="less" scoped>
@import '../css/IncentiveTravel.less';
</style>



// WEBPACK FOOTER //
// src/pages/IncentiveTravel.vue